// Authentication related pages
import { Suspense, lazy } from 'react';
import { LoginWithRedirect } from '../pages/Authentication/Login';
import { SignUp } from '../pages/Authentication/SignUp';

import { CalcType } from 'api';
import { AllowedAction } from 'api';
import { OpportunityRedirect } from '../pages/Opportunity/OpportunityRedirect';
import { ShowcaseView } from 'design-system';
import { LoadingScreen } from '../components/Common/LoadingScreen';

const loadable = (importFunc) => {
	const LazyComponent = lazy(importFunc);
	return (props) => (
		<Suspense fallback={<LoadingScreen />}>
			<LazyComponent {...props} />
		</Suspense>
	);
};

// Inner Authentication
const Dashboard = loadable(() => import('dashboard'));
// const Dashboard = loadable(() => import('../pages/Dashboard'));
const CommingSoon = loadable(() => import('../pages/Utility/CommingSoon'));
const Error404 = loadable(() => import('../pages/Utility/Error404'));
const Error500 = loadable(() => import('../pages/Utility/Error500'));
const Maintenance = loadable(() => import('../pages/Utility/Maintenance'));
// const InnerAuthentication = lazy(() => import('../pages/InnerAuthentication'));
const CalculatorEditor = loadable(() => import('../pages/Calculator/CalculatorEditor'));
// const Search = loadable(() => import('../pages/Search'));
const ConfiguratorLanding = loadable(() => import('../pages/Configurator/ConfiguratorLanding'));
const SystemValues = loadable(() => import('../pages/Configurator/Constants/SystemValues'));
const OptionWizard = loadable(() => import('../pages/Configurator/Options/OptionWizard'));
const PortfolioWizard = loadable(() => import('../pages/Configurator/Portfolio/PortfolioWizard'));
const OptionsLanding = loadable(() => import('../pages/Configurator/Options/OptionsLanding'));
const CustomLightbox = loadable(() => import('../pages/Custom/CustomLightbox'));
const Notifications = loadable(() => import('../pages/Notifications'));
const ErrorLogin = loadable(() => import('../pages/Utility/ErrorLogin'));
const SalesOfferView = loadable(() => import('sales-offer'));
const CustomFieldConfigurator = loadable(() => import('custom-field-configurator'));
const ApprovalFlow = loadable(() => import('approval-flow'));
const OfferSearch = loadable(() => import('offer-search'));
// Components

const authProtectedRoutes = [
	{ path: '/dashboard', component: Dashboard },
	{ path: '/notifications', component: Notifications },
	{
		path: '/offer',
		component: SalesOfferView,
		actions: [AllowedAction.CreateOffer]
	},
	{ path: '/offer-search', component: OfferSearch },
	{
		path: '/administration-portfolio',
		component: ConfiguratorLanding,
		actions: [AllowedAction.ChangeConfiguration]
	},
	{
		path: '/custom-field-configurator',
		component: CustomFieldConfigurator,
		actions: [AllowedAction.ChangeConfiguration]
	},
	{
		path: '/portfolio-wizard',
		component: PortfolioWizard,
		actions: [AllowedAction.ChangeConfiguration]
	},
	{
		path: '/calculator-configurator',
		component: CalculatorEditor,
		state: { calcType: CalcType.Standard },
		actions: [AllowedAction.ChangeConfiguration]
	},
	{
		path: '/administration-option',
		component: OptionsLanding,
		actions: [AllowedAction.ChangeConfiguration]
	},
	{
		path: '/option-wizard',
		component: OptionWizard,
		actions: [AllowedAction.ChangeConfiguration]
	},
	{
		path: '/system-values',
		component: SystemValues,
		actions: [AllowedAction.ChangeConfiguration]
	},
	{
		path: '/dev-showcase',
		component: ShowcaseView
	},
	{ path: '/approval/:id', component: ApprovalFlow, isMobileRoute: true },
	{ path: '/approval-dashboard', component: ApprovalFlow, isMobileRoute: true },
	//{ path: "/context", component: A1Context }, // testing route

	//triple
	{ path: '/custom-lightbox', component: CustomLightbox },
	{
		path: '/dev-showcase',
		component: ShowcaseView
	},

	// this route should be at the end of all other routes
	{ path: '/', exact: true, component: Dashboard }
];

const publicRoutes = [
	//{ path: "/logout", component: Logout },
	//{ path: "/login", component: Login },
	//{ path: "/forgot-password", component: ForgetPwd },
	{ path: '/login', component: LoginWithRedirect },
	{ path: '/signup', component: SignUp },
	//{ path: "/auth-lock-screen", component: AuthLockScreen },

	// Authentication Inner
	//{ path: "/auth-login", component: Login1 },
	//{ path: "/auth-register", component: Register1 },
	//{ path: "/auth-recoverpw", component: ForgetPwd1 },

	{ path: '/pages-maintenance', component: Maintenance },
	{ path: '/pages-comingsoon', component: CommingSoon },
	{ path: '/pages-404', component: Error404 },
	{ path: '/pages-500', component: Error500 },
	{ path: '/error-login', component: ErrorLogin },
	{
		path: '/new-offer',
		component: OpportunityRedirect
	}
];

export { authProtectedRoutes, publicRoutes };
